import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { LangContext } from "../../context/langContext";

export function LanguageOption({ language, languagesId, changeLanguages }) {

    const { locale } = useContext(LangContext);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setChecked(languagesId.includes(language.id))
    }, [])

    return (
        <label for={language.name} className='option'>
            <input type="checkbox" id={language.name} name="language" value={language.id} onClick={changeLanguages} checked={checked} onChange={(e) => {
                setChecked(e.target.checked)
            }} />
            {(locale === 'es-CO') ? language.nombre : language.name}</label>
    )
}


export function CategoriesOption({ category, categoriesId, changeCategories }) {

    const { locale } = useContext(LangContext);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setChecked(categoriesId.includes(category.id))
    }, [])

    return (
        <label for={category.name} className='option'>
            <input type="checkbox" id={category.name} name="language" value={category.id} onClick={changeCategories} checked={checked} onChange={(e) => {
                setChecked(e.target.checked)
            }} />
            {(locale === 'es-CO') ? category.nombre : category.name}
        </label>
    )
}